module.exports = __webpack_public_path__ + "media/醒來的第一個念頭就是我好想好想你.7ac79028.mp3";